import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';

import { IdDescricao } from '@app/models/util/id-descricao';
import { DRPorTipo } from './drportipo.model';

import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ConsultasService } from '@app/services/consultas.service';


@Component({
  selector: 'app-reldrportipo',
  templateUrl: 'drportipo.component.html',
  styleUrls: ['drportipo.component.scss']
})
export class RelatorioDRPorTipoComponent implements OnInit {


  lstUnidade: IdDescricao[] = [];
  lstTipoDR: IdDescricao[] = [];
  lstDR: DRPorTipo[];

  cdsMask: CDSMask = new CDSMask();

  tipoId?: number = null;

  dataInicial = '';
  dataFinal = '';
  regime = 'CAIXA';
  unidadeId: number;
  pesquisando: boolean = false;
  showTable: boolean = false;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService) {
    this.dataInicial = UtilitarioService.retornaDataPrimeiroDiaDoMes();
    this.dataFinal = UtilitarioService.retornaDataUltimoDiaDoMes();
  }

  ngOnInit() {
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidade = data);
    this.consultasService.consultar('DR').toPromise().then(data => this.lstTipoDR = data);
  }

  obterDRE() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService.drPorTipo(this.tipoId, this.dataInicial, this.dataFinal, this.regime)
      .toPromise()
      .then((data: DRPorTipo[]) => {
        this.lstDR = data;
        this.pesquisando = false;
        if (this.lstDR.length == 0) {
          this.toastr.info("Busca não encontrou resultados");
          this.showTable = false;
        } else {
          this.showTable = true;
        }
      }, erro => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      });
    //  () => this.pesquisando = false);
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("demostrativoDeResultado").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Demonstrativo de Resultados por Tipo", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Regime', this.regime === 'COMPETENCIA' ? 'Competência' : 'Caixa');
    
    parseDateAdicionaMap('Data Inicial', this.dataInicial);
    parseDateAdicionaMap('Data Final', this.dataFinal);
    
    obtemDescricaoAdicionaMap('Tipo', this.lstTipoDR, this.tipoId);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }
}

